module.exports = __webpack_public_path__ + "img/mint-count-frame.e9ba06b4.png";